import React from 'react';
import "./NotFound.scss";

const NotFound = () => {
  return (
    <div className='not-found my-5'>
      <div className='container flex align-center justify-center'>
        No food found.
      </div>
    </div>
  )
}

export default NotFound